import axiosInstance from './axiosInstance';

export type WorkerNoteType = 'CALL' | 'MEETING' | 'WHATSAPP' | 'NOTE';

export interface WorkerNote {
    id: string;
    workerId: string;
    type: WorkerNoteType;
    body: string;
    authorSubject: string;
    authorLabel: string;
    durationMinutes?: number | null;
    createdAt: string;
}

export type WorkerTimelineItemKind = 'NOTE' | 'CHAT_MESSAGE' | 'ADMIN_MESSAGE';

export interface WorkerTimelineItem {
    sourceId: string;
    kind: WorkerTimelineItemKind;
    occurredAt: string;
    body: string;
    noteType?: WorkerNoteType;
    authorSubject?: string;
    authorLabel?: string;
    durationMinutes?: number | null;
    sessionId?: number;
    direction?: 'INCOMING' | 'OUTGOING';
    senderType?: string;
    adminUsername?: string | null;
}

export interface WorkerTimelinePage {
    items: WorkerTimelineItem[];
    nextCursor: string | null;
}

export interface SaveWorkerNoteRequest {
    type: WorkerNoteType;
    body: string;
    durationMinutes?: number | null;
}

const workerPath = (workerId: string) => `/workers/${encodeURIComponent(workerId)}`;
const WORKER_TIMELINE_PAGE_SIZE = 50;

export async function fetchWorkerTimeline(workerId: string, cursor?: string): Promise<WorkerTimelinePage> {
    const response = await axiosInstance.get<WorkerTimelinePage>(`${workerPath(workerId)}/timeline`, {
        params: {
            limit: WORKER_TIMELINE_PAGE_SIZE,
            ...(cursor ? { cursor } : {}),
        },
    });
    return response.data;
}

export async function createWorkerNote(workerId: string, payload: SaveWorkerNoteRequest): Promise<WorkerNote> {
    const response = await axiosInstance.post<WorkerNote>(`${workerPath(workerId)}/notes`, payload);
    return response.data;
}

export async function updateWorkerNote(
    workerId: string,
    noteId: string,
    payload: Partial<SaveWorkerNoteRequest>,
): Promise<WorkerNote> {
    const response = await axiosInstance.patch<WorkerNote>(
        `${workerPath(workerId)}/notes/${encodeURIComponent(noteId)}`,
        payload,
    );
    return response.data;
}

export async function deleteWorkerNote(workerId: string, noteId: string): Promise<void> {
    await axiosInstance.delete(`${workerPath(workerId)}/notes/${encodeURIComponent(noteId)}`);
}
